// Portfolio data for Whisky Woven
// Source of truth: /app/frontend/src/data/portfolio.json
// Add/edit images there — this file just transforms it for the UI.

import data from './data/portfolio.json';

export const CATEGORIES = [
  { id: 'characters', label: 'Character Portraits', description: 'Cinematic character imagery for unforgettable faces' },
  { id: 'creatures', label: 'Creatures & Beasts', description: 'Fantasy creatures, companions, and beasts brought to life' },
  { id: 'worlds', label: 'World & Scene', description: 'Atmospheric environments and immersive settings' },
  { id: 'videos', label: 'Video Trailers', description: 'Short-form cinematic trailers that stop the scroll' },
];

// Derive a human-friendly title from an image URL if one wasn't provided.
const titleFromUrl = (url = '') => {
  try {
    const file = decodeURIComponent(url.split('/').pop() || '').replace(/\.[^.]+$/, '');
    const clean = file.replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
    return clean ? clean.replace(/\b\w/g, (c) => c.toUpperCase()) : 'Untitled';
  } catch {
    return 'Untitled';
  }
};

const imageCategories = ['characters', 'creatures', 'worlds'];

export const portfolioImages = imageCategories.flatMap((cat) =>
  (data[cat] || []).map((item, idx) => ({
    id: `${cat}-${idx + 1}`,
    title: item.title?.trim() || titleFromUrl(item.image),
    description: item.description?.trim() || '',
    image: item.image,
    category: cat,
  }))
);

export const youtubeVideos = (data.videos || []).map((item, idx) => ({
  id: `v${idx + 1}`,
  title: item.title?.trim() || `Trailer ${idx + 1}`,
  description: item.description?.trim() || '',
  videoId: item.videoId,
  thumbnail: `https://img.youtube.com/vi/${item.videoId}/mqdefault.jpg`,
  category: 'videos',
  featured: !!item.featured,
  orientation: item.orientation || 'horizontal',
}));

export const featuredVideo = youtubeVideos.find((v) => v.featured) || null;

// Optional per-category cover override; falls back to first image / video thumbnail.
export const categoryCovers = data.covers || {};
